var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.empresas.length > 1 ? _c('b-dropdown', {
    staticClass: "empresa-selector",
    attrs: {
      "size": "sm",
      "variant": "link",
      "toggle-class": "empresa-selector__toggle text-decoration-none",
      "right": "",
      "no-flip": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "svg-icon svg-icon-lg empresa-selector__icon"
        }, [_c('inline-svg', {
          attrs: {
            "src": "media/svg/icons/Home/Building.svg"
          }
        })], 1), _c('span', {
          staticClass: "empresa-selector__text"
        }, [_c('small', [_vm._v("Empresa atual")]), _c('strong', [_vm._v(_vm._s(_vm.empresaAtualNome))])]), _vm.trocando ? _c('span', {
          staticClass: "spinner spinner-sm spinner-light ml-2",
          attrs: {
            "aria-label": "Trocando empresa"
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, false, 1340135196)
  }, [_c('b-dropdown-header', [_vm._v("Trocar de empresa")]), _vm._l(_vm.empresas, function (empresa) {
    return _c('div', {
      key: empresa.id_empresa,
      staticClass: "empresa-selector__option"
    }, [_c('button', {
      staticClass: "dropdown-item empresa-selector__company-button",
      class: {
        active: _vm.isEmpresaAtual(empresa)
      },
      attrs: {
        "type": "button",
        "disabled": _vm.trocando || _vm.isEmpresaAtual(empresa)
      },
      on: {
        "click": function click($event) {
          return _vm.selecionarEmpresa(empresa);
        }
      }
    }, [_c('span', {
      staticClass: "empresa-selector__option-name"
    }, [_vm._v(" " + _vm._s(_vm.nomeEmpresa(empresa)) + " ")]), _c('span', {
      staticClass: "d-flex align-items-center ml-3"
    }, [_vm.isEmpresaPadrao(empresa) ? _c('span', {
      staticClass: "badge badge-light-warning mr-2"
    }, [_vm._v(" Padrão ")]) : _vm._e(), empresa.tipo_grupo ? _c('span', {
      staticClass: "badge badge-light"
    }, [_vm._v(" " + _vm._s(_vm.tipoEmpresa(empresa)) + " ")]) : _vm._e()])]), _c('button', {
      staticClass: "btn btn-sm btn-icon empresa-selector__default-button",
      class: _vm.isEmpresaPadrao(empresa) ? 'btn-light-warning' : 'btn-light',
      attrs: {
        "type": "button",
        "disabled": _vm.salvandoPadrao || _vm.isEmpresaPadrao(empresa),
        "title": _vm.isEmpresaPadrao(empresa) ? 'Empresa padrão' : 'Definir como empresa padrão',
        "aria-label": _vm.isEmpresaPadrao(empresa) ? "".concat(_vm.nomeEmpresa(empresa), " \xE9 a empresa padr\xE3o") : "Definir ".concat(_vm.nomeEmpresa(empresa), " como empresa padr\xE3o")
      },
      on: {
        "click": function click($event) {
          return _vm.definirEmpresaPadrao(empresa);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-star",
      class: _vm.isEmpresaPadrao(empresa) ? 'text-warning' : 'text-muted'
    })])]);
  })], 2) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };